import { BRAND } from "../lib/constants";

/**
 * Large ISA shield watermark for page hero sections.
 * Sits behind hero content as a brand mark, fading softly at the edges.
 *
 * Usage: place inside a `relative overflow-hidden` hero <section>.
 */
export const HeroShield = ({ position = "right" }) => {
  const positionClass =
    position === "left"
      ? "left-[-6%] lg:left-[-4%]"
      : position === "center"
      ? "left-1/2 -translate-x-1/2"
      : "right-[-8%] lg:right-[-4%]";

  return (
    <div
      aria-hidden="true"
      data-testid="hero-shield-watermark"
      className={`pointer-events-none absolute top-1/2 -translate-y-1/2 ${positionClass} w-[460px] h-[460px] sm:w-[560px] sm:h-[560px] lg:w-[760px] lg:h-[760px] select-none z-0`}
      style={{
        maskImage:
          "radial-gradient(circle at center, rgba(0,0,0,1) 35%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0) 78%)",
        WebkitMaskImage:
          "radial-gradient(circle at center, rgba(0,0,0,1) 35%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0) 78%)",
      }}
    >
      <img
        src={BRAND.logoShield}
        alt=""
        className="w-full h-full object-contain opacity-[0.40] drop-shadow-[0_0_60px_rgba(212,175,55,0.35)]"
        draggable={false}
      />
    </div>
  );
};

export default HeroShield;
